export default __webpack_public_path__ + "static/media/022-Spider Man.a2bf5b3b.svg";